<template>
    <div class="PjanNavigationbar">
        <div class="tab_content" v-show="highcourt">
            <div class="tab_sent sent"  @click="substance('/xzproceeding')">
                <p>老赖”生活的限制，一文讲清！</p>
                <span>2023-05-25</span>
            </div>
            <div class="tab_sent" @click="substance('/sdproceeding')">
                <p>视点深度｜首度亮相的民事强制执行法草案亮点解析</p>
                <span>2023-05-25</span>
            </div>
            <div class="tab_sent" @click="substance('/csproceeding')">
                <p>限制“老赖”措施汇总（2022年版）</p>
                <span>2023-05-25</span>
            </div>
        </div>
        <router-view v-show="!highcourt"/>
        <!-- <xzproceeding v-show="highcourt"/> -->
        <!-- <xzproceeding v-show="highcourt"/> -->
        <!-- <xzproceeding v-show="highcourt"/> -->
    </div>
</template>
<script>
import xzproceeding from '../../views/article/proceeding/xzproceeding.vue'
import sdproceeding from '../../views/article/proceeding/sdproceeding.vue'
import csproceeding from '../../views/article/proceeding/csproceeding.vue'
export default {
    data() {
        return {
            highcourt:true
        }
    },
    components:{
        xzproceeding,
        sdproceeding,
        csproceeding
    },
    mounted(){
        setTimeout(() => {
            if(JSON.parse(sessionStorage.getItem("ssfwzn")) == '1') this.substance('/xzproceeding')
            else if(JSON.parse(sessionStorage.getItem("ssfwzn")) == '2') this.substance('/sdproceeding')
            else if(JSON.parse(sessionStorage.getItem("ssfwzn")) == '3') this.substance('/csproceeding')
        },500)
    },
    methods:{
        substance(data){
            // this.highcourt = false
            if(data == this.$route.path) return
            this.$router.push(data)
        }
    },
    watch:{
        $route(to,from){
            if(to.path == '/SfwznNavigationbar'){
                this.highcourt = true
            }else{
                if(this.$route.path == '/xzproceeding' || this.$route.path == '/sdproceeding' || this.$route.path == '/csproceeding'){
                    this.highcourt = false
                }else{
                    return 
                }
                
            }
        }
    }
}
</script>
<style lang="less" scoped>
.PjanNavigationbar{
    width: 100%;
    .tab_content{
        p{
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .tab_sent:hover p,.tab_sent:hover span{
            color:#BE1A0F;
        }
    }
}
</style>
